import { Component, OnInit } from '@angular/core';
import { AbstractDialogComponent } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sales-accelerator-info-dialog',
  templateUrl: './sales-accelerator-info-dialog.component.html',
  styleUrls: ['./sales-accelerator-info-dialog.component.scss'],
})
export class SalesAcceleratorInfoDialogComponent extends AbstractDialogComponent implements OnInit {
  message: string;

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 0) {
      this.message = this.inputs[0];
    }
  }
}
